import {MGiftVoucher} from '../../../master-files/m-gift-voucher/model/m-gift-voucher';

export class TGiftVoucherTransferItem {
  indexNo: number;
  mGiftVoucher: MGiftVoucher;
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-gift-voucher-transfer/model/t-gift-voucher-transfer-item.ts